import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { HugeiconsIcon } from "@hugeicons/react";
import { Download01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { QRCodeCanvas } from "qrcode.react";

interface PaymentLinkQrCodeProps {
  url: string;
  fileName: string;
  size?: number;
}

const PaymentLinkQrCode: React.FC<PaymentLinkQrCodeProps> = ({
  url,
  fileName,
  size = 160,
}) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    const canvas = containerRef.current?.querySelector("canvas");
    if (!canvas) return;

    const link = document.createElement("a");
    link.download = `${fileName}.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "var(--space-4)",
      }}
    >
      <Box ref={containerRef}>
        <QRCodeCanvas value={url} size={size} level="M" marginSize={2} />
      </Box>
      <Button
        variant="default-outlined"
        startIcon={<HugeiconsIcon icon={Download01Icon} size={18} />}
        onClick={handleDownload}
      >
        {t("Download")}
      </Button>
    </Box>
  );
};

export default PaymentLinkQrCode;
